import {
  GraphQLFieldConfig,
  GraphQLString,
  GraphQLNonNull,
  GraphQLList,
  GraphQLID,
  GraphQLObjectType
} from 'graphql'
import { Context } from '../shared'
import { Application } from '../types/application'

interface ApplicationNames {
  readonly items: Array<Partial<Application>>
}

const ApplicationNameType = new GraphQLObjectType({
  name: 'ApplicationName',
  fields: () => ({
    id: {
      description: 'The unique ID for an application',
      type: new GraphQLNonNull(GraphQLID)
    },
    name: {
      description: 'Human readable name for the application',
      type: new GraphQLNonNull(GraphQLString)
    }
  })
})

const ApplicationNamesQueryType = new GraphQLObjectType({
  name: 'ApplicationNames',
  fields: () => ({
    items: {
      type: new GraphQLNonNull(new GraphQLList(ApplicationNameType))
    }
  })
})

export const applicationNames: GraphQLFieldConfig<
  any,
  Context,
  { readonly organizationID: string }
> = {
  description: 'Get all application IDs and names',
  type: new GraphQLNonNull(ApplicationNamesQueryType),
  args: {
    organizationID: {
      description: 'The unique ID for the organization being queried',
      type: new GraphQLNonNull(GraphQLID)
    }
  },
  async resolve(_source, args, context): Promise<Partial<ApplicationNames>> {
    const { organizationID } = args

    const { applications = [] } = await context.connector.get(
      `/${organizationID}/applications/name`
    )

    return {
      items: applications.map(({ app_id, ...app }) => ({ id: app_id, ...app }))
    }
  }
}
